import React, { useState } from 'react';
import { getBaseUrl } from '../config';
import { useToast } from './Toast';

const LoginTest = ({ config, onBack }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null); // { success: boolean, message: string, token?: string }
  const showToast = useToast();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);

    try {
      // Use the dedicated auth endpoint
      const url = `${getBaseUrl()}/auth/${config.tableName}/login`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          [config.userField]: username,
          [config.passwordField]: password
        })
      });
      
      const data = await response.json();

      if (response.status === 200) {
        setResult({
          success: true,
          message: `Login successful!`,
          token: data.token || data.jwt || data.access_token
        });
      } else if (response.status === 401) {
        setResult({
          success: false,
          message: 'Invalid credentials. No matching record found.'
        });
      } else {
        throw new Error(data.error || `Server returned ${response.status}`);
      }
    } catch (err) {
      setResult({
        success: false,
        message: `Error during login: ${err.message}`
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: '600px', marginTop: '3rem' }}>
      <div className="box">
        <div className="level mb-5">
          <div className="level-left">
            <button className="button is-ghost pl-0" onClick={onBack}>
              <span className="icon">
                <i className="bi bi-arrow-left"></i>
              </span>
              <span>Back to Tables</span>
            </button>
          </div>
        </div>

        <h1 className="title is-4 has-text-centered mb-6">
          <span className="icon-text">
            <span className="icon has-text-warning mr-2">
              <i className="bi bi-lock-fill"></i>
            </span>
            <span>Login: {config.tableName}</span>
          </span>
        </h1>

        <form onSubmit={handleLogin}>
          <div className="field">
            <label className="label">{config.userField.charAt(0).toUpperCase() + config.userField.slice(1)}</label>
            <div className="control has-icons-left">
              <input
                className="input"
                type="text"
                placeholder={`Enter ${config.userField}`}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <span className="icon is-small is-left">
                <i className="bi bi-person"></i>
              </span>
            </div>
          </div>

          <div className="field">
            <label className="label">Password</label>
            <div className="control has-icons-left">
              <input
                className="input"
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span className="icon is-small is-left">
                <i className="bi bi-key"></i>
              </span>
            </div>
          </div>

          <div className="field mt-5">
            <div className="control">
              <button 
                className={`button is-primary is-fullwidth ${loading ? 'is-loading' : ''}`}
                type="submit"
              >
                Login
              </button>
            </div>
          </div>
        </form>

        {result && (
          <div className={`notification mt-5 ${result.success ? 'is-success' : 'is-danger'} is-light`}>
            <button className="delete" onClick={() => setResult(null)}></button>
            <p>
              <span className="icon mr-2">
                <i className={`bi ${result.success ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'}`}></i>
              </span>
              {result.message}
            </p>
            {result.token && (
              <div className="mt-4">
                <p className="is-size-7 mb-1"><strong>JWT Token:</strong></p>
                <div className="control">
                  <textarea 
                    className="textarea is-small has-fixed-size" 
                    readOnly 
                    value={result.token}
                    rows={4}
                    style={{ fontFamily: 'monospace' }}
                  />
                </div>
                <button 
                  className="button is-small is-link is-light mt-2"
                  onClick={() => {
                    navigator.clipboard.writeText(result.token);
                    showToast('Token copied to clipboard!', 'success');
                  }}
                >
                  <span className="icon is-small">
                    <i className="bi bi-clipboard"></i>
                  </span>
                  <span>Copy Token</span>
                </button>
              </div>
            )}
          </div>
        )}
        
        <div className="content is-small mt-6 has-text-grey has-text-centered">
          <p>
            Note: This login attempt searches for an exact match of the provided credentials 
            in the <code>{config.tableName}</code> table.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginTest;
